var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.path}},[_vm._v(_vm._s(`${_vm.text}${_vm.timerHidden ? '' : '(' + _vm.num+'s)' }`))])
}
var staticRenderFns = []

export { render, staticRenderFns }